"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOpportunityActivitiesResponseDto = exports.InnerDataWrapperDto = exports.StageDto = exports.ActivityDto = exports.ParticipantDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
// Participant DTO
class ParticipantDto {
}
exports.ParticipantDto = ParticipantDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1, description: "The ID of the participant (user)." }),
    tslib_1.__metadata("design:type", Number)
], ParticipantDto.prototype, "userId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "testing1",
        description: "The name of the participant.",
    }),
    tslib_1.__metadata("design:type", String)
], ParticipantDto.prototype, "userName", void 0);
// Activity DTO
class ActivityDto {
}
exports.ActivityDto = ActivityDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 15 }),
    tslib_1.__metadata("design:type", Number)
], ActivityDto.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 3 }),
    tslib_1.__metadata("design:type", Number)
], ActivityDto.prototype, "activityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Mandate Details Entry" }),
    tslib_1.__metadata("design:type", String)
], ActivityDto.prototype, "activityName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "true" }),
    tslib_1.__metadata("design:type", String)
], ActivityDto.prototype, "activityApproval", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "true" }),
    tslib_1.__metadata("design:type", String)
], ActivityDto.prototype, "activityMandatory", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "2025-05-10", nullable: true }),
    tslib_1.__metadata("design:type", Object)
], ActivityDto.prototype, "dueDate", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: [ParticipantDto] }),
    tslib_1.__metadata("design:type", Array)
], ActivityDto.prototype, "participants", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: null, nullable: true }),
    tslib_1.__metadata("design:type", Object)
], ActivityDto.prototype, "leadDays", void 0);
// Stage DTO
class StageDto {
}
exports.StageDto = StageDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1 }),
    tslib_1.__metadata("design:type", Number)
], StageDto.prototype, "stageId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Initial Contact" }),
    tslib_1.__metadata("design:type", String)
], StageDto.prototype, "stageName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: [ActivityDto] }),
    tslib_1.__metadata("design:type", Array)
], StageDto.prototype, "activities", void 0);
// Inner data wrapper
class InnerDataWrapperDto {
}
exports.InnerDataWrapperDto = InnerDataWrapperDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: [StageDto] }),
    tslib_1.__metadata("design:type", Array)
], InnerDataWrapperDto.prototype, "data", void 0);
// Final response DTO
class GetOpportunityActivitiesResponseDto {
}
exports.GetOpportunityActivitiesResponseDto = GetOpportunityActivitiesResponseDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 200 }),
    tslib_1.__metadata("design:type", Number)
], GetOpportunityActivitiesResponseDto.prototype, "status", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "Opportunity Activities retrieved successfully",
    }),
    tslib_1.__metadata("design:type", String)
], GetOpportunityActivitiesResponseDto.prototype, "message", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: InnerDataWrapperDto }),
    tslib_1.__metadata("design:type", InnerDataWrapperDto)
], GetOpportunityActivitiesResponseDto.prototype, "data", void 0);
